import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    input,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import type { GridItemAlignment } from './leading';

@Component({
    selector: 'qpx-grid-item',
    imports: [MatCardModule],
    templateUrl: './grid-item.html',
    styleUrl: './grid-item.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'block h-full min-w-0',
        '[attr.data-align]': 'align()',
        '[attr.align]': 'null',
        '[attr.data-selected]': 'selected() ? "true" : null',
    },
})
export class QpxGridItem {
    public readonly align = input<GridItemAlignment>('start');
    public readonly selected = input(false, { transform: booleanAttribute });
    public readonly hoverable = input(false, { transform: booleanAttribute });
}
